/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {defineStyle} from '@chakra-ui/system';

export const markupStyles = defineStyle({
  '.amb-markup': {
    'h1, h2, h3, h4, h5, h6': {mb: '0.5rem'},
    'h1': {fontSize: '2.5rem'},
    'h2': {fontSize: '2rem'},
    'h3': {fontSize: '1.75rem'},
    'h4': {fontSize: '1.5rem'},
    'h5': {fontSize: '1.25rem'},
    'h6': {fontSize: '1rem'},
    'hr': {my: '1rem'},
    'p': {mb: '1rem'},
  },
});
